import type { ReactNode } from 'react';

import { Typography } from '@mui/material';

import { InkSparkleIcon } from '@/components/shared/AgentAssistantPopup/InkSparkleIcon';
import {
  HeadingGroup,
  QuickAction,
  QuickActionIcon,
  Suggestions,
  TopGlow,
  WelcomeHeader,
  WelcomeRoot,
} from '@/components/shared/AgentAssistantPopup/styles';
import type { AgentAssistantWelcome } from '@/components/shared/AgentAssistantPopup/types';

export type InkAssistantWelcomeProps = {
  welcome: AgentAssistantWelcome;
  /** Send the chosen suggestion as a user message and start a run. */
  onSelectSuggestion: (message: string) => void;
  exiting?: boolean;
};

export const InkAssistantWelcome = ({
  welcome,
  onSelectSuggestion,
  exiting,
}: InkAssistantWelcomeProps) => {
  const { heading, subtitle, suggestions, icon } = welcome;

  const renderIcon = (custom: ReactNode) =>
    custom ? <QuickActionIcon>{custom}</QuickActionIcon> : null;

  return (
    <WelcomeRoot exiting={exiting}>
      <TopGlow aria-hidden />
      <WelcomeHeader>
        {icon ?? <InkSparkleIcon size={36} />}
        <HeadingGroup>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, color: 'text.primary', textAlign: 'center' }}
          >
            {heading}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', textAlign: 'center' }}
          >
            {subtitle}
          </Typography>
        </HeadingGroup>
      </WelcomeHeader>
      <Suggestions>
        {suggestions.map((suggestion) => (
          <QuickAction
            key={suggestion.label}
            type="button"
            onClick={() =>
              onSelectSuggestion(suggestion.message ?? suggestion.label)
            }
          >
            {renderIcon(suggestion.icon)}
            <Typography variant="body2" sx={{ color: 'text.primary' }}>
              {suggestion.label}
            </Typography>
          </QuickAction>
        ))}
      </Suggestions>
    </WelcomeRoot>
  );
};
